import { render } from "./MainLayout.vue?vue&type=template&id=e35504ae&scoped=true&ts=true"
import script from "./MainLayout.vue?vue&type=script&lang=ts"
export * from "./MainLayout.vue?vue&type=script&lang=ts"

import "./MainLayout.vue?vue&type=style&index=0&id=e35504ae&scoped=true&lang=scss"

import exportComponent from "/var/www/ment-test/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e35504ae"]])

export default __exports__